import { $$, addEventListenerAll } from '../helper/utils';

const langSelect = $$('.lang-switch > button');

export default function langSwitch() {
  // toggle open class on click
  addEventListenerAll(langSelect, 'click', function () {
    this.parentElement.classList.toggle('open');
  }, { passive: true });

  // remove open class on outside click
  window.addEventListener('click', (e) => {
    for (let i = 0; i < langSelect.length; i++) {
      const el = langSelect[i].parentElement;
      if (e.target !== el && el.contains(e.target) === false) {
        el.classList.remove('open');
      }
    }
  });

  // remove open class when tabbing out
  for (let i = 0; i < langSelect.length; i++) {
    const el = langSelect[i].parentElement;
    el.addEventListener('focusout', function () {
      this.classList.remove('open');
    });
  }
}
